import { deriveElementCrossSectionAssignment } from '../utils/deriveElementAssignments'
import { getModel } from './model'

/**
 * Derived from planar model — CS lives on beam/column/purlin/rip/lintel elements.
 * Query key kept for call-site compatibility; prefer invalidating getModel after writes.
 */
export const getElementCrossSectionAssignment: RequestTypeVariable = {
  getKey: id => ['getElementCrossSectionAssignment', id],
  request: async (id: string): Promise<ElementCSAssignment[]> => {
    const model = await getModel.request(id)
    return deriveElementCrossSectionAssignment(model)
  },
}
